import(/* webpackMode: "eager" */ "/app/src/app/bang-gia/page.js");
